import {
    FETCH_CASHOUTS_REQUEST,
    FETCH_CASHOUTS_SUCCESS,
    FETCH_CASHOUTS_FAILURE,
    UPDATE_CASHOUT_REQUEST,
    UPDATE_CASHOUT_SUCCESS,
    UPDATE_CASHOUT_FAILURE,
} from "../actions/types";

const initialState = {
    cashouts: [],
    page: 1,
    size: 10,
    count: 0,
    loading: false,
    error: null,
    message: "",
};

const cashoutReducer = (state = initialState, action) => {
    switch (action.type) {

        case FETCH_CASHOUTS_REQUEST:
        case UPDATE_CASHOUT_REQUEST:
            return { ...state, loading: true, error: null };

        case FETCH_CASHOUTS_SUCCESS:
            return {
                ...state,
                loading: false,
                cashouts: action.payload.cashouts,
                page: action.payload.page,
                size: action.payload.size,
                count: action.payload.count,
                message: "Cashouts loaded successfully",
            };

        case UPDATE_CASHOUT_SUCCESS:
            return {
                ...state,
                loading: false,
                cashouts: state.cashouts.map((c) =>
                    c.cashout_id === action.payload.id
                        ? {
                            ...c,
                            status: action.payload.status,
                            status_reason: action.payload.status_reason,
                        }
                        : c
                ),
                message: "Cashout updated successfully",
            };

        case FETCH_CASHOUTS_FAILURE:
        case UPDATE_CASHOUT_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};

export default cashoutReducer;